import { render, staticRenderFns } from "./rasoStep2.vue?vue&type=template&id=1dab0284&scoped=true&"
import script from "./rasoStep2.vue?vue&type=script&lang=js&"
export * from "./rasoStep2.vue?vue&type=script&lang=js&"
import style0 from "./rasoStep2.vue?vue&type=style&index=0&id=1dab0284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dab0284",
  null
  
)

export default component.exports